import LatLngOverlay from './latlng-overlay';
import RoamTool from './roam-tool';

export default function useTools(
  mapInstance: LooseObject | null,
  containerDom: HTMLElement,
  mapProps: LooseObject,
): LooseObject {
  if (!mapInstance) return {};

  const mapToolInstanceData = new Map();

  const mapToolAttrsHandlers = {
    enableRealtimeLatlng(enable: boolean): void {
      if (enable) {
        mapInstance?.on('mousemove', createRealtimeLatlngOverlay);
        containerDom.addEventListener('mouseleave', onLeaveContainer);
        containerDom.addEventListener('mouseenter', onEnterContainer);
      } else {
        mapInstance?.off('mousemove', createRealtimeLatlngOverlay);
        containerDom.removeEventListener('mouseleave', onLeaveContainer);
        containerDom.removeEventListener('mouseenter', onEnterContainer);
      }
    },
    measureToolType(type: string): void {
      const tool = getMeasureTool();
      if (type === 'disable') {
        tool.disable();
        return;
      }
      tool.enable();
      if (type === 'distance') {
        tool.measureDistance().then(() => mapToolAttrsHandlers.measureToolType(type));
      } else {
        tool.measureArea().then(() => mapToolAttrsHandlers.measureToolType(type));
      }
    },
    enableRoam(enable: boolean) {
      const tool = getRoamTool();
      enable ? tool.start() : tool.stop();
    },
    roamDuration(val: number) {
      const tool = getRoamTool();
      tool.setDuration(val);
      mapProps.enableRoam && tool.start();
    },
    roamLoop(val: number) {
      const tool = getRoamTool();
      tool.setLoop(val);
      mapProps.enableRoam && tool.start();
    },
    roamData(data: RoamKeyFrame[]) {
      const tool = getRoamTool();
      tool.setData(data);
      mapProps.enableRoam && tool.start();
    },
  };

  // 实时坐标显示
  const createRealtimeLatlngOverlay = (e: MapEvent): void => {
    showLatLng(e.latLng);
  };

  const showLatLng = (position: LatLng): void => {
    if (!mapToolInstanceData.has('enableRealtimeLatlng')) {
      mapToolInstanceData.set('enableRealtimeLatlng', new LatLngOverlay({
        map: mapInstance,
        position,
      }));
    } else {
      const overlay = mapToolInstanceData.get('enableRealtimeLatlng');
      overlay.updatePosition(position);
      overlay.updateDOM();
    }
  };

  const handleRealtimeOverlayVisible = (visible: boolean): void => { // 处理鼠标移出地图组件，实时坐标仍显示的问题
    if (!mapToolInstanceData.has('enableRealtimeLatlng')) return;
    mapToolInstanceData.get('enableRealtimeLatlng').setMap(visible ? mapInstance : null);
  };

  const onLeaveContainer = (): void => {
    handleRealtimeOverlayVisible(false);
  };

  const onEnterContainer = (): void => {
    handleRealtimeOverlayVisible(true);
  };

  // 测量工具
  const getMeasureTool = (): LooseObject => {
    if (!mapToolInstanceData.has('measureToolType')) {
      mapToolInstanceData.set('measureToolType', new TMap.tools.MeasureTool({
        map: mapInstance,
      }));
    }
    return mapToolInstanceData.get('measureToolType');
  };

  // 地图漫游
  const getRoamTool = (): RoamTool => {
    if (!mapToolInstanceData.has('roamTool')) {
      mapToolInstanceData.set('roamTool', new RoamTool(
        mapInstance,
        mapProps.roamData,
        mapProps.roamLoop,
        mapProps.roamDuration,
      ));
    }
    return mapToolInstanceData.get('roamTool');
  };

  // 销毁时清空map结构
  const destroyTools = (): void => {
    mapToolInstanceData.forEach(tool => tool.destroy());
    mapToolInstanceData.clear();
  };

  return {
    mapToolAttrsHandlers,
    destroyTools,
  };
}
